import dynamic from "next/dynamic"
import { getGlobals } from "storyblok/api"
import { getIndividualWinOrReview, getWinsAndReviewsPaths } from "storyblok/winsAndReviews"
import PageHeader from "components/DynamicComponent/molecules/PageHeader"
import StoryblokVisualEditor from "components/StoryblokVisualEditor"
import ArticleSection from "components/Archive/ArticleSection"
import Meta from "components/Meta"
import richText from "utilities/richText"
import { getPlainText } from "utilities/getPlainText"

export default function IndividualPracticeArea({ story }) {
  const Video =
    story?.content?.component === "video_review"
      ? dynamic(() => import("../../components/DynamicComponent/atoms/InlineVideo"))
      : () => null

  const Stars =
    story?.content?.component === "client_review"
      ? dynamic(() => import("../../components/DynamicComponent/atoms/Stars"))
      : () => null

  return (
    <>
      <Meta
        info={{
          title: story?.content?.title,
          og_title: story?.content?.title,
          twitter_title: story?.content?.title,
          description: getPlainText(story?.content?.subheading),
          og_description: getPlainText(story?.content?.subheading),
        }}
      />
      <main data-pagefind-body data-pagefind-sort="weight[data-weight]" data-weight="8">
        <StoryblokVisualEditor>
          <PageHeader
            blok={{
              type: "standard",
              heading: story?.content?.title,
              content: story?.content?.subheading,
              breadcrumbs: [{ text: "Wins & Reviews", href: "/wins-and-reviews" }, { text: story?.content?.title }],
            }}
          />
          <ArticleSection>
            <Video blok={{ video: story?.content?.video }} title={story?.content?.title} />
            <Stars blok={{ rating: story?.content?.stars }} />
            {richText(story?.content?.content)}
          </ArticleSection>
        </StoryblokVisualEditor>
      </main>
    </>
  )
}

export async function getStaticProps({ params: { review }, preview = null }) {
  const globals = await getGlobals("exclude-global-sections")

  const page = await getIndividualWinOrReview(`wins-and-reviews/${review}`, preview)

  return {
    props: {
      meta: page?.content?.twentysixty_seo ?? null,
      story: page ?? null,
      globals: globals ?? null,
      preview,
    },
  }
}

export async function getStaticPaths() {
  return {
    paths: await getWinsAndReviewsPaths(),
    fallback: false,
  }
}
